import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  MANAGE_USER: {
    path: `${baseRoutes.adminBaseRoutes}/users`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon-user-settings" />
      </span>
    ),
  },
  USER_DETAILS: {
    path: `${baseRoutes.adminBaseRoutes}/user-details`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
  },
};

export default accessRoute;
